module.exports = __webpack_public_path__ + "static/media/colheitadeira.07cd2b81.svg";